// One ID per page session — regenerated on full reload.
export const correlationId: string = crypto.randomUUID();
